import axios from 'axios'
import { getToken, logout, restoreOriginalSession, isImpersonating, getSessionHomePath } from './auth'


const urls = {
  'url': (process.env.REACT_APP_HUB_API_URL || '').replace('/amei.cloud', ''),
  'whith-amei-cloud': process.env.REACT_APP_HUB_API_URL,
  'whatsapp': process.env.REACT_APP_WHATSAPP_SERVICE_API,
}

export const api = axios.create({
  baseURL: urls['whith-amei-cloud'],
  timeout: 30000,
})

export const apiSimple = axios.create({
  baseURL: urls['url'],
  timeout: 30000,
})

export const apiWhatsapp = axios.create({
  baseURL: urls['whatsapp'],
  timeout: 30000,
})

const isTokenExpired = (error) =>
  (error?.response?.status === 401 || error?.response?.status === 403) &&
  /token expirado/i.test(error?.response?.data?.friendly_message || '')

apiSimple.interceptors.request.use(async (config) => {
  const token = getToken()

  config.headers['unic-request'] = `${new Date()} - ${Math.random()}`

  if (token) config.headers.Authorization = `${token}`

  return config
})

api.interceptors.request.use(async (config) => {
  const token = getToken()

  config.headers['unic-request'] = `${new Date()} - ${Math.random()}`

  if (token) config.headers.Authorization = `${token}`

  return config
})

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (isTokenExpired(error)) {
      if (isImpersonating() && restoreOriginalSession()) {
        window.location = getSessionHomePath()
      } else {
        logout()
        window.location = '/'
      }

      return Promise.reject(
        Object.assign(error, { __handled: true, __sessionExpired: true }),
      )
    }

    return Promise.reject(error)
  },
)


export default api
